<template>
    <div>
       <productComponentVue></productComponentVue>
    </div>
</template>

<script>
import productComponentVue from '@/components/Admin/Component/ProductComponent/productComponent.vue';
export default {
    name: 'PadmawebSavingView',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
    components:{
        productComponentVue
    }
};
</script>

<style lang="scss" scoped>

</style>